import React, { useState } from "react";
import { Typography } from "@mui/material";
import { getIcon } from "@dishopsaas/design-system";
import Modal from "../../Modal/Modal.view";
import { useSignInSignUp } from "../../../hooks/useSignInSignUp";
interface VerificationModalProps {
  email: string;
  onClose: () => void;
  onResendCode?: () => void;
  loading?: boolean;
}

const VerificationModal: React.FC<VerificationModalProps> = ({
  email,
  onClose,
  onResendCode,
  loading = false,
}) => {
  const [code, setCode] = useState("");
  const [verificationLoading, setVerificationLoading] = useState(false);
  const [verificationError, setVerificationError] = useState("");
  const { handleVerificationSuccess } = useSignInSignUp();
  const handleResendCode = () => {
    setVerificationError("");
  };

  const handleSubmit = () => {
    if (code.length === 4) {
      handleVerifyCode(code);
    }
  };
  const handleVerifyCode = async (code: string) => {
    setVerificationLoading(true);
    setVerificationError("");

    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (code === "1234") {
        setVerificationError("");
        handleVerificationSuccess();
      } else {
        setVerificationError("Code incorrect. Essayez 1234 pour le test.");
      }
    } catch (error) {
      setVerificationError("Erreur lors de la vérification");
    } finally {
      setVerificationLoading(false);
    }
  };
  const handleCodeChange = (value: string) => {
    const numericValue = value.replace(/\D/g, "").slice(0, 4);
    setVerificationError("");
    setCode(numericValue);
  };
  return (
    <Modal
      title="SAISIR LE CODE DE SÉCURITÉ"
      subtitle={
        <>
          Saisissez le code à 4 chiffres envoyé sur votre adresse email :{" "}
          <Typography component="p" fontWeight="bold">
            {email}
          </Typography>
        </>
      }
      icon="code"
      isLoading={verificationLoading}
      inputField={{
        label: "Code à 4 chiffres",
        value: code,
        onChange: (e) => handleCodeChange(e.target.value),
        placeholder: "Code reçu par email",
        error: !!verificationError,
        helperText: verificationError,
        inputProps: { maxLength: 4 },
        leftIcon: getIcon("lock"),
        labelAdornment: (
          <Typography
            variant="body2"
            sx={{
              color: "primary.main",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: 500,
            }}
            onClick={handleResendCode}
          >
            Renvoyer le code
          </Typography>
        ),
      }}
      primaryButton={{
        label: "CONTINUER",
        onClick: handleSubmit,
        disabled: code.length !== 4,
        loading: loading,
      }}
      secondaryButton={{
        label: "RETOUR",
        onClick: onClose,
      }}
    />
  );
};

export default VerificationModal;
